import { render, staticRenderFns } from "./Activdea.vue?vue&type=template&id=1e224ccc&scoped=true"
import script from "./Activdea.vue?vue&type=script&lang=js"
export * from "./Activdea.vue?vue&type=script&lang=js"
import style0 from "./Activdea.vue?vue&type=style&index=0&id=1e224ccc&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e224ccc",
  null
  
)

export default component.exports